import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'> {
  variant?: ButtonVariant;
  size?: 'sm' | 'md';
  /** Teljes szélesség — mobilon a legtöbb elsődleges akció ilyen. */
  block?: boolean;
  /** Betöltés közben a gomb letiltva és pörgő jelet mutat. */
  loading?: boolean;
  icon?: ReactNode;
  /**
   * Csak ikon, felirat nélkül — négyzetes gomb.
   *
   * ⚠️ ILYENKOR AZ `aria-label` KÖTELEZŐ. Felirat nélkül a gombnak nincs
   * elérhető neve: a felolvasó annyit mondana, hogy „gomb". A prop nem tudja
   * kikényszeríteni, de a hívóhelyeken ez a szabály.
   */
  iconOnly?: boolean;
  children?: ReactNode;
}

export function Button({
  variant = 'primary',
  size = 'md',
  block = false,
  loading = false,
  icon,
  iconOnly = false,
  children,
  disabled,
  type = 'button',
  ...rest
}: ButtonProps) {
  const classes = [
    'btn',
    `btn--${variant}`,
    size === 'sm' ? 'btn--sm' : '',
    block ? 'btn--block' : '',
    iconOnly ? 'btn--icon' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <span className="btn__spinner" aria-hidden="true" /> : icon}
      {children}
    </button>
  );
}
